import React, { useEffect, useMemo } from 'react';
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';
import { defaultSelectedESport, defaultSelectedSport } from '../../constants/defaultValues';
import SportsContainer from './Container/Container';
import EventsLayout from '../Layouts/EventsLayout/EventsLayout';
import { useDispatch } from 'react-redux';
import { setSocketContext } from '../../store/actions/socketAction';
import { changeEventFilters, setCompetitionType, setESportsType } from '../../store/actions/sportEvents';

const SportsRoutes = ({ isLive, isESports }) => {
    const dispatch = useDispatch();
    const match = useRouteMatch();

    const defaultSport = useMemo(() => (isESports ? defaultSelectedESport : defaultSelectedSport), [isESports]);

    useEffect(() => {
        dispatch(setSocketContext({ isLive, isESports }));
        dispatch(setCompetitionType(isLive));
        dispatch(setESportsType(isESports));

        return () => {
            dispatch(setCompetitionType(null));
            dispatch(setESportsType(null));
            dispatch(changeEventFilters({ filters: {}, shouldUpdateEvents: false }));
        };
    }, []);

    return (
        <EventsLayout isLive={isLive}>
            <Switch>
                <Redirect exact from={`${match.url}/`} to={`${match.path}/${defaultSport.referenceId}`} />
                <Route exact path={`${match.url}/:sportRefId`} component={SportsContainer} />
                <Route
                    exact
                    path={`${match.url}/:sportRefId/events/:eventId/markets`}
                    render={() => <SportsContainer showAllMarkets={true} />}
                />
            </Switch>
        </EventsLayout>
    );
};

export default SportsRoutes;
